import { render, staticRenderFns } from "./LeadProfile.vue?vue&type=template&id=554f8902"
import script from "./LeadProfile.vue?vue&type=script&lang=js"
export * from "./LeadProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports